<ng-template #popTemplate>
    <div *ngIf="!isVylorTenant()">
        <div *ngIf="isLoading" class="kt-align-center">
            <i class="fa fa-spin fa-spinner"></i>
        </div>
        <div *ngIf="loadingError" class="kt-align-center">
            An error has occurred <i class="fa fa-refresh" (click)="getProgramLastRunDates()"></i>
        </div>
        <table *ngIf="this.programLastRunTimes != null">
            <tr *ngFor="let program of this.programLastRunTimes.programLastRunTimes">
                <td>{{ program.programName }}</td>
                <td>{{ program.lastRunTime.toFormat("MM/DD/YY hh:mm a") }}</td>
            </tr>
            <tr *ngIf="this.programLastRunTimes.lrpLastRunTime != null">
                <td>LRP</td>
                <td>{{ this.programLastRunTimes.lrpLastRunTime.toFormat("MM/DD/YY hh:mm a") }}</td>
            </tr>
        </table>
        <div class="LRPCompletionStatus">LRP Completion Status</div>
        <div class="progress" *ngIf="this.programLastRunTimes?.lrpCompletionPercent != null">
            <div class="progress-bar bg-success" role="progressbar"
                [style.width]="this.programLastRunTimes.lrpCompletionPercent + '%'" [attr.aria-valuenow]="this.programLastRunTimes.lrpCompletionPercent" aria-valuemin="0"
                aria-valuemax="100">
                {{this.programLastRunTimes.lrpCompletionPercent}}%</div>
        </div>
        <div *ngIf="this.programLastRunTimes?.lrpCompletionPercent == null">
            <span>LRP job is not started yet.</span>
        </div>

    </div>
</ng-template>
<div class="kt-nav__link" id="m_topbar_program_last_runtimes" [popover]="popTemplate" triggers="mouseenter:mouseleave">
    <span class="custom-color">
        <i class="pi pi-calendar"></i> {{l('ProgramLastRunTimes')}}
    </span>
</div>
